<template>
    <page title="chill">
        <div class="center">
            <iframe
                width="100%"
                height="1000px"
                src="https://www.youtube-nocookie.com/embed/5qap5aO4i9A"
                frameborder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen />
        </div>
    </page>
</template>

<script>
import Page from '@/components/layout/Page';
export default { components: { Page } };
</script>

<style scoped>
.center {
    display: flex;
    justify-content: center;
}
</style>